import { Link } from "react-router-dom";
import { formatDate } from "../../../utils";

const BlogList = ({ blogs }) => {
    return (
          <div className="row justify-content-center">
            {blogs.map((blog) => (
                <div key={blog?.id} className="blog-grid-card col-lg-4 col-md-6 col-sm-10">
                    <div className="blog-grid-item">
                        <div className="blog-grid-thumb">
                            <Link to={`/blog/${blog?.slug}`}>
                                <img src={blog?.image} alt={blog?.title} />
                            </Link>
                        </div>
                        <div className="blog-grid-content">
                            <span className="date desc">{formatDate(blog?.created_at)}</span>
                            <span className="date desc">{blog?.author}</span>
                            <h2 className="title">
                                <Link to={`/blog/${blog?.slug}`}>
                                    {blog?.title}
                                </Link>
                            </h2>
                            <div>
                                {blog?.short_description}
                            </div>
                        </div>
                    </div>
                </div>
            ))}
          </div>
      )
}

export default BlogList